import './i18n'
import React from 'react'
import SiteShell from './components/app/SiteShell'

export default function App() {
    return <SiteShell />
}